import React from "react";
import styled from "styled-components";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import SmartLink from "partials/SmartLink";
import Image from "partials/Image";

import Media from "css/Media";

function LogoLinkList({ data }) {
  return (
    <ModuleWrapper>
      <Container grid>
        <GridElement
          colStart={{ default: 1, s: 7 }}
          colEnd={{ default: 8, s: 18 }}
        >
          <FlexWrapper listLength={data.items.length}>
            {data.items.map((item) => {
              return (
                <SmartLink
                  to={item.link.url}
                  target={item.link.target}
                  key={item.link.url}
                >
                  <Image
                    image={item.image}
                    background
                    ratio='1:1'
                    backgroundSize='contain'
                  />
                </SmartLink>
              );
            })}
          </FlexWrapper>
        </GridElement>
      </Container>
    </ModuleWrapper>
  );
}

export default LogoLinkList;

const ModuleWrapper = styled.div`
  margin: ${(props) => props.theme.spacing.elementM} 0 0;

  ${Media.greaterThan("s")`
      margin: ${(props) => props.theme.spacing.blockXS} 0 0;
  `}
`;

const FlexWrapper = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.listLength === 4 ? "space-between" : "center"};
  align-items: center;

  > a {
    width: 75px;
    margin-right: ${(props) => props.theme.spacing.contentXL};
    &:last-of-type {
      margin-right: 0;
    }
  }
`;
